export default "__VITE_ASSET__DuhvUMA6__"